import React, {useEffect, useMemo, useState} from 'react'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {KTSVG, dateTimeFormat} from '../../../../_metronic/helpers'
import {Spinner} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate, Link} from 'react-router-dom'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {
  GetSavedCampaigsList,
  getAllSavedCampaignsList,
} from '../new-message/BulkMessageSlice/BulkMessageSlice'
import NodataYet from '../../../Components/NodataYet'
import InsertNewData from '../../../Components/InsertNewData'
import {DeleteDraftCampaign} from './OurTemplates/OurTemplateSlice/OurTemplateSlice'
import ReactPaginate from 'react-paginate'

const SavedCampaign = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const SavedCampaignList = useSelector(getAllSavedCampaignsList)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })

  const [visible, setVisible] = useState<any>(false)
  const [loading, setLoading] = useState<any>(false)

  useEffect(() => {
    setLoading(true)
    dispatch(GetSavedCampaigsList()).then(() => {
      setLoading(false)
    })
  }, [])

  useEffect(() => {
    setLoading(true)
    dispatch(GetSavedCampaigsList(page)).then(() => {
      setLoading(false)
    })
  }, [page])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete template ?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  useEffect(() => {
    if (confirm == true) {
      // dispatch(DeleteTemplate(deleteIds))
      dispatch(DeleteDraftCampaign({id: deleteIds}))
      setConfirm(false)
    }
  }, [confirm])

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  return (
    <>
      {confirmation}
      <div className={`card`}>
        <div className='card-header border-0 pt-12 px-14'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Saved Campaign</span>
            <span className='text-muted mt-1 fw-bold fs-7'>
              This is where you can find all your saved campaigns
            </span>
          </h3>
        </div>
        {loading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : SavedCampaignList?.data?.items?.length > 0 ? (
          <div className='card-body py-3 px-14'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-400 text-muted'>
                    <th className='min-w-125px'>NAME</th>
                    <th className='min-w-125px'>CREATED</th>
                    <th className='min-w-250px'>CONTENT</th>
                    <th className='ps-4 min-w-125px'>STATUS</th>
                    <th className='min-w-150px text-end'>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {SavedCampaignList?.data?.items?.map((data: any, idx: number) => (
                    <tr key={idx}>
                      <td>
                        <span className='text-dark  fw-bolder d-block mb-1 fs-6'>{data?.name}</span>
                        <span className='text-bold-400 '>{data?.nameSub}</span>
                      </td>
                      <td>
                        <span className='text-dark fw-400  d-block mb-1 fs-6'>
                          {dateTimeFormat(data?.createdAt, 'MMM DD YYYY')}
                        </span>
                      </td>
                      <td>
                        <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.message}</span>
                      </td>
                      <td className='ps-3'>
                        <span
                          className={
                            data?.camp_type === 'MMS'
                              ? 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                              : 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 w-50px py-5'
                          }
                        >
                          {data?.camp_type?.toUpperCase()}
                        </span>
                      </td>
                      <td className='ms-2 text-end'>
                        {AuthenticateUser('edit-template') && (
                          <button
                            className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'
                            onClick={() =>
                              navigate('/new-message', {
                                state: {
                                  selectedType: 'draft',
                                  data: {
                                    ...data,
                                    saveCampaignId: {value: data?._id, label: ''},
                                    media: data?.media?.url,
                                    urlData: data?.media,
                                    senderType: data?.senderType ? data?.senderType : '',
                                    sender: data?.sender
                                      ? {
                                          value: data?.sender,
                                          label: `${
                                            data?.sender
                                          }-${data?.camp_type?.toUpperCase()}`,
                                        }
                                      : '',
                                  },
                                },
                              })
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/art/art005.svg'
                              className='svg-icon-2'
                            />
                          </button>
                        )}
                        {AuthenticateUser('delete-template') && (
                          <button
                            className='btn btn-sm btn-icon trash btn-light btn-active-light-primary'
                            onClick={() => handleDelete(data?._id)}
                          >
                            <KTSVG
                              className='svg-icon-2'
                              path='/media/icons/duotune/art/trush.svg'
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <InsertNewData
            message={{
              title: `You don't have any drafts yet`,
              subtitle: `Maybe it's time to create a campaign?`,
            }}
            buttonName={{
              name: 'Send new message',
              link: '/new-message',
              popup: false,
            }}
          />
        )}

        <div className='abcd px-8'>
          <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
          </select>
          <ReactPaginate
            previousLabel='<'
            nextLabel='>'
            pageCount={SavedCampaignList?.data?.totalPages}
            onPageChange={(e: any) => setPage({...page, page: e.selected + 1})}
            containerClassName={'pagiantion'}
            previousLinkClassName={'pagination__link'}
            nextLinkClassName={'pagination__link'}
            disabledClassName={'pagination__link--disabled'}
            activeClassName={'pagination__link--active'}
          />
        </div>
      </div>
    </>
  )
}

export default SavedCampaign
